// ----------      START   IMPORT  BLOCK       ----------
import APIService from '../../Core/APIService';
import API_ROUTES from '../../../ConfigFiles/Routes/api_routes';
import type { PickerOption } from '../../../Components/Widgets/LoggedUserGeneral/ProOnboarding/Steps/Widgets/SpecialtySubPicker';
// ----------      END   IMPORT  BLOCK       ----------

export default class StateService extends APIService {
  /**
   * Searches geographical states by query string with optional AbortSignal for request cancellation.
   */
  async searchState(query: string, signal?: AbortSignal): Promise<PickerOption[]> {
    if (!query || query.trim().length < 2) return [];

    try {
      const route = API_ROUTES.search_state(encodeURIComponent(query));
      const response = await this.get<PickerOption[]>(
        route, 
        signal ? { signal } : undefined
      );
      return response || [];
    } catch (error: any) {
      if (error?.name === 'CanceledError' || error?.name === 'AbortError' || error?.code === 'ERR_CANCELED') {
        // Silent handle for debounced/canceled requests
        return [];
      }
      console.error('State service search failed:', error);
      throw error;
    }
  }
}